export const CALENDLY_DEMO_URL = "https://calendly.com/jayesh-neiv/30min";

// WhatsApp support number in international format, digits only (country code
// + number, no "+", spaces, or dashes). Placeholder — replace with the real
// NEIV support number.
export const WHATSAPP_PHONE = "9213847500";

export const getWhatsAppUrl = (text = "") =>
  `https://wa.me/${WHATSAPP_PHONE}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
